import(/* webpackMode: "eager" */ "/learn-web/features/common/containers/GoogleReCaptchaProvider/GoogleReCaptchaProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/learn-web/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
